export type TagVariant = 'light' | 'outline' | 'purple';
export type TagSize = 'small';

export enum TTagSeverity {
  ERROR = 'Feil',
  WARNING = 'Advarsel',
  SUCCESS = 'Suksess',
  INFORMATION = 'Informasjon',
  NEUTRAL = 'Nøytral',
}
export type TagProps = {
  children: React.ReactNode;
  variant?: TagVariant;
  closable?: boolean;
  onClose?: () => void;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  severity?: TTagSeverity;
};
